//https://script.google.com/macros/s/AKfycbyrRMBYyq4TSBSa5vNOVY1_f2Y70c7acUmLsy9Sl_kJACbehZ0/exec

export function addEmail(email) {
  return fetch('https://script.google.com/macros/s/AKfycbyrRMBYyq4TSBSa5vNOVY1_f2Y70c7acUmLsy9Sl_kJACbehZ0/exec?email=' + email, {
    method : 'GET'
  })
}
